module.exports = __webpack_public_path__ + "img/investmentVal.bcd28f3a.svg";